export default __webpack_public_path__ + "static/media/tp-logo.c3ba444d.png";